













import { Vue, Component, Prop } from 'vue-property-decorator'

type BubbleType = 'dark' | 'light' | 'dashed' | 'light-2'

@Component
export default class Bubble extends Vue {
  @Prop({ default: 'div' }) readonly element!: string
  @Prop({ default: 'dark' }) readonly type!: BubbleType
}
